import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Landing } from './pages/Landing';
import { NotAFit } from './pages/NotAFit';
import { ThankYou } from './pages/ThankYou';
export function App() {
  return <BrowserRouter data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/" element={<Landing data-id="element-3" />} data-id="element-2" />
        <Route path="/not-a-fit" element={<NotAFit data-id="element-5" />} data-id="element-4" />
        <Route path="/thankyou" element={<ThankYou data-id="element-7" />} data-id="element-6" />
      </Routes>
    </BrowserRouter>;
}